import { render } from "./AlienDatabase.vue?vue&type=template&id=7f11c316"
import script from "./AlienDatabase.vue?vue&type=script&lang=js"
export * from "./AlienDatabase.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__